import { InjectionToken } from '@angular/core';

export const APPLICATION_WINDOW = new InjectionToken<Window>('student_portal.application_window');
